import Layout from "../include/layout";
import { Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from 'dayjs'
import { Link, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import 'datatables.net-bs5'
import Filarial from "../include/filarial";
import NotesService from "./NotesService";
import ApprenantsService from "../apprenants/ApprenantsService";

export default function NotesIndex() {
    const activeLink = "NOTES ET MOYENNES"

    const token = useSelector(state => state.auth.token)
    const [notes, setNotes] = useState([])
    const [apprenants, setApprenants] = useState([]);

    const navigate = useNavigate()
    //check if user is authenticated
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticate)

      //get liste apprenants
      const fetchApprenants = async () => {
        await ApprenantsService.index(token).then((res) => {
            //console.log(res.data.data.apprenants)
            setApprenants(res.data.data.apprenants)
        }).catch(error => {
            console.log(error)
        })
        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //get liste notes
    const fetchNotes = async () => {
        await NotesService.index(token).then((res) => {
            setNotes(res.data.data.notes)
        }).catch(error => {
            console.log(error)
        })

        //initialize datatable
        $(document).ready(function () {
            $('.data-table').DataTable();
        });
    }

    //redirection sur la page edit sans afficher les id dans l'url
    const goToEdit = (param) => {
        navigate(myroutes.notes_edit, { state: { id: param } })
    }

    //suppression d'un élément
    const onDelete = (param) => {
        //confirm action
        Swal.fire({
            icon: "warning",
            text: "Voulez-vous confirmer cette action ?",
            showCancelButton: true,
            cancelButtonText: "Non",
            confirmButtonText: "Oui",
            confirmButtonColor: "red"
        }).then(result => {
            if (result.isConfirmed) {
                NotesService.delete(param, token).then((response) => {
                    //console.log(response.data)
                    if (response.data.status !== 200) {
                        Swal.fire({
                            icon: "error",
                            text: response.data.message
                        })
                    } else {
                        Swal.fire({
                            icon: "success",
                            text: response.data.message
                        })
                        fetchNotes()
                    }
                }).catch(e => {
                    Swal.fire({
                        icon: "error",
                        text: e.message
                    })
                    console.log(e)
                })
            }
        })
    }

    // formater les date de début et fin
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "numeric", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
      };


    useEffect(() => {

        fetchNotes();
        // Vérifier si l'utilisateur est connecté lors du chargement de l'application
        dispatch(checkAuthenticate());
        if (!isAuthenticated) {
            //console.log(isAuthenticated)
            //Redirection sur le dashboard
            navigate(myroutes.login)
        }
    }, [dispatch])


    return (
        <Layout>
            <div className="container-xxl flex-grow-1 container-p-y">

                <Filarial activeLink={activeLink} />


                {/* Responsive Datatable */}
                <div className="card shadow-lg mb-4 mt-3">
                    <h5 className="card-header">Récapitulatif des notes &nbsp;&nbsp;
                        <Link to={myroutes.notes_create}
                            className="btn btn-warning btn-sm"
                            title="Ajouter"
                        ><FontAwesomeIcon icon="fa-solid fa-circle-plus" /></Link>
                    </h5>
                    <div className="card-datatable table-responsive px-4 pb-3">
                        <table className="dt-responsive table border-top data-table table-hover ">
                            <thead className="bg-primary">
                                <tr style={{ color: "white" }}>
                                    <th className="cell text-white">#</th>
                                    <th className="cell text-white">N° Mat</th>
                                    <th className="cell text-white">Nom et Prénoms</th>
                                    <th className="cell text-white">annee academique </th>
                                    <th className="cell text-white">Classe option</th>
                                    <th className="cell text-white">Période</th>
                                    <th className="cell text-white">Matiere</th>
                                    <th className="cell text-white">Int 1</th>
                                    <th className="cell text-white">Int 2</th>
                                    <th className="cell text-white">Int 3</th>
                                    <th className="cell text-white">Int 4</th>
                                    <th className="cell text-white">Int 5</th>
                                    <th className="cell text-white">Moy Int</th>
                                    <th className="cell text-white">Dev 1</th>
                                    <th className="cell text-white">Dev 2</th>
                                    <th className="cell text-white">Moy Gen</th>
                                    <th className="cell text-white">Moy Sem</th>
                                    <th className="cell text-white">Appreciation</th>
                                    <th className="cell text-white">Date modifcation</th>
                                    <th className="cell text-white">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                            {notes.length > 0 && notes.map((item, index) => (
                                    <tr key={index}>
                                        <td className="cell">{index + 1}</td>
                                        <td className="cell">{}</td>
                                        <td className="cell">{} </td>
                                        <td className="cell">{}</td>
                                        <td className="cell">{item.classesoptions?.libelleClasseOption}</td>
                                        <td className="cell">{}</td>
                                        <td className="cell">{item.matieres?.libelleMatiere} </td> 
                                        <td className="cell">{item.noteinterrogation1DetailNote}</td>
                                        <td className="cell">{item.noteinterrogation2DetailNote}</td>
                                        <td className="cell">{item.noteinterrogation3DetailNote}</td>
                                        <td className="cell">{item.noteinterrogation4DetailNote}</td>
                                        <td className="cell">{item.noteinterrogation5DetailNote}</td>
                                        <td className="cell">{item.moyenneinterrogationDetailNote}</td>
                                        <td className="cell">{item.notedevoir1DetailNote} </td>
                                        <td className="cell">{item.notedevoir2DetailNote}</td>
                                        <td className="cell">{item.moyennegeneraleDetailNote} </td>
                                        <td className="cell">{item.moyennecoefficieeDetailNote}</td>
                                        <td className="cell">{item.appreciation} </td>
                                        <td className="cell">{}</td>
                                        <td className="cell">
                                            <div className="d-flex">
                                                <Button className="btn btn-sm" variant="primary" onClick={() => goToEdit(item.id)}
                                                    title="Modifier">
                                                    <i className="fas fa-edit"></i></Button> &nbsp;&nbsp;

                                                <Button className="btn btn-sm" variant="danger" onClick={() => onDelete(item.id)}
                                                    title="Supprimer">
                                                    <i className="fas fa-trash"></i></Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/*/ Responsive Datatable */}
            </div>


        </Layout>
    )
}